import React, { Component } from 'react';

/*
 * A container that uses render props to wrap a given trust pilot widget
 */
class TrustpilotContainer extends Component {
  constructor(props) {
    super(props);
    this.trustBoxRef = React.createRef();
  }

  componentDidMount() {
    if (__CLIENT__ && window.Trustpilot) {
      // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
      // If it's not, it means the script you pasted into <head /> isn't loaded just yet.
      // When it is, it will automatically load the TrustBox.
      window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
    }
  }

  render() {
    return this.props.render({ trustBoxRef: this.trustBoxRef });
  }
}

export default TrustpilotContainer;
